// Message Board共通のカラーパレット
export const colors = {
  'keijiban-coral': 'rgba(255, 89, 62, 1)',
  'keijiban-coral-bg': 'rgba(255, 238, 235, 1)',
  'keijiban-brown': 'rgba(94, 40, 29, 1)',
  'text-default': 'rgba(0, 0, 0, 0.87)',
  'text-secondary': 'rgba(0, 0, 0, 0.54)',
  'border-light': 'rgba(0, 0, 0, 0.095)',
  'background-light': 'rgba(248, 248, 248, 1)',
  'white': 'rgba(255, 255, 255, 1)',
  'primary': '#F70816',
}
